import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { createContext, useCallback, useContext, useState } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies

import { isJapaneseLanguage, usePreferredLanguage } from '@atlassian/commerce-credit-card-base';

// TODO: Move this to HAMS?
var acceptedBrands = ['mastercard', 'amex', 'visa'];
var ACCEPTED_BRANDS_ERROR_MESSAGE = 'Only Visa, MasterCard and AMEX are supported';

// TODO: Remove this once proper i18n is supported
var JAPANESE_ACCEPTED_BRANDS_ERROR_MESSAGE = 'このクレジットカードには対応していません';
var getAcceptedLanguageErrorMessage = function getAcceptedLanguageErrorMessage(language) {
  if (isJapaneseLanguage(language)) {
    return JAPANESE_ACCEPTED_BRANDS_ERROR_MESSAGE;
  }
  return ACCEPTED_BRANDS_ERROR_MESSAGE;
};
var extractCreditCardNumberChangePayloadBrandError = function extractCreditCardNumberChangePayloadBrandError(payload, language) {
  if (payload.brand === 'unknown') {
    if (payload.complete) {
      return {
        message: getAcceptedLanguageErrorMessage(language)
      };
    }
  } else if (!payload.empty && !acceptedBrands.includes(payload.brand)) {
    return {
      message: getAcceptedLanguageErrorMessage(language)
    };
  }
  return undefined;
};
var brandErrorContext = /*#__PURE__*/createContext(undefined);
export var useBrandError = function useBrandError() {
  return useContext(brandErrorContext);
};
var setBrandErrorContext = /*#__PURE__*/createContext(undefined);
export var useOnCardNumberChangeBrandValidation = function useOnCardNumberChangeBrandValidation() {
  var setBrandError = useContext(setBrandErrorContext);
  var language = usePreferredLanguage();
  var setBrandErrorFomCardNumberChangeEvent = useCallback(function (payload) {
    var brandError = extractCreditCardNumberChangePayloadBrandError(payload, language);
    setBrandError(brandError);
    if (brandError !== undefined && payload.error === undefined) {
      return _objectSpread(_objectSpread({}, payload), {}, {
        error: {
          // Would rather not pretend this is a validation error from Stripe itself
          code: 'invalid_number',
          message: brandError.message,
          type: 'validation_error'
        }
      });
    }
    return payload;
  }, [setBrandError, language]);
  return setBrandErrorFomCardNumberChangeEvent;
};
export var BrandValidationProvider = function BrandValidationProvider(_ref) {
  var children = _ref.children;
  var _useState = useState(undefined),
    _useState2 = _slicedToArray(_useState, 2),
    brandError = _useState2[0],
    setBrandError = _useState2[1];
  return /*#__PURE__*/React.createElement(brandErrorContext.Provider, {
    value: brandError
  }, /*#__PURE__*/React.createElement(setBrandErrorContext.Provider, {
    value: setBrandError
  }, children));
};